import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  files?: File;
  feedbackType: string;
  text: string;
}

const helpMutation = () => useMutation({
  mutationKey: ['helpAndDesk'],
  mutationFn: (body: Props) => {
    const formData = new FormData();

    if (body.files?.name) {
      formData.append('files', body.files);
    }

    formData.append('feedbackType', body.feedbackType);
    formData.append('text', body.text);

    const config = {
      headers: {
        ...agent.getClient()['defaults'].headers.common,
        'Content-Type': 'multipart/form-data',
      },
    };

    return agent.getClient().post('/feedback/send', formData, config);
  },
  onSuccess: () => { },
});

export default helpMutation;
